import { render, staticRenderFns } from "./AddEditGroup.vue?vue&type=template&id=d4e42b2a&scoped=true"
import script from "./AddEditGroup.vue?vue&type=script&lang=js"
export * from "./AddEditGroup.vue?vue&type=script&lang=js"
import style0 from "./AddEditGroup.vue?vue&type=style&index=0&id=d4e42b2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e42b2a",
  null
  
)

export default component.exports